import React from 'react'
import { Link } from 'react-router-dom'

function Columbs() {
    return (
        <div className='font-thin'>
              <div className="w-full px-6 md:px-16  mx-auto  max-w-7xl">
    
    {/* ✅ Breadcrumb Navigation */}
    <div className="flex justify-start text-sm md:text-base">
           <Link to="/" className="block py-1 pl-4 hover:underline  mt-6">Home -</Link>
           <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline mt-6">Typologies -</Link>
           <Link to="/display" className="block py-1 pl-4 hover:underline mt-6">Display -</Link>
           <span className="block py-1 pl-4 mt-6">COLUMBUS</span>
    
         </div>
         {/* ✅ Product Image on Top */}
         <div className="flex justify-center mb-6">
           <img src="/images/newcolumbs.jpg" alt="Vista" className="max-w-full h-auto object-contain" />
         </div>
    
         {/* ✅ Product Title & Description */}
         <div className="text-center mb-6">
           <h1 className="text-3xl md:text-4xl uppercase mb-8">COLUMBUS</h1>
           <p className="text-xl md:text-2xl font-thin max-w-sm mx-auto text-gray-500">High capacity and visibility without obstacles.</p>
           <p className="text-xl md:text-2xl font-thin opacity-80 max-w-7xl mx-auto text-gray-500 mt-10">COLUMBUS is a line of serve-overs with high exposition capacity designed to equip modern nourishment distribution. Having heated and cooled versions, for service and self-service, the Columbus line is the ideal choice for the exposition of Butchery, Charcuterie, Fish, Seafood and Take-away products.</p>
         </div>
    
         {/* ✅ Models & Model Values */}
    <h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Models for</h2>
    
    <div className="grid grid-cols-1 gap-4 text-center mb-6">
      
       <p className="text-xl md:text-2xl opacity-90">MEAT & CHARCUTERIE  <span className=' text-blue-400'>-1… +5 °C</span> <span className='text-gray-500'>(3M1)</span></p>
       <p className="text-xl md:text-2xl opacity-90">DAIRY PRODUCTS <span className=' text-blue-400'> -1… +7 °C</span> <span className='text-gray-500'>(3M2)</span></p>
       </div>
    
    
         {/* ✅ Refrigeration */}
         <div>
           <h2 className="text-3xl font-thin text-center mt-10 text-gray-500 ">Refrigeration</h2>
           <p className="text-xl md:text-2xl text-lime-500 text-center mt-3">CO2 | Glycol </p>
         </div>
    
    
    
         {/* ✅ Case Images & Features */}
         <div className="flex flex-col gap-8 pt-32">
            {/* case 1 */}
             <div 
               className="flex flex-col  pb-16 mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
                {/* ✅ Image Wrapper */}
                <div className="w-full md:w-1/2">
                 <img src="/images/columcase.jpg" className="max-w-full h-auto object-contain" />
               </div>
               <div className="w-full md:w-1/2 px-4"> 
        <p className="text-2xl">Perfect visibility, without obstacles, for Meat, Cheese and Charcuterie.</p>
        <ul className="list-[square] list-outside text-gray-500">
  <li className="text-xl  font-thin opacity-90 mt-6">
    Fan assisted cooling system which assures an even temperature distribution.
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
    Line predisposed for remote condensing units.
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
    Stainless steel inside, resistant and easy to sanitize.
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
    Wide exposition area with 95 cm.
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
    Total visibility, front glass without any technical element.
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
    Version with pedestal or with front decoration, which adapts to your business.
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
    Semi vertical with high exhibition capacity for self-service of packed products.
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
    LED lighting of high brightness and high energy efficiency.
  </li>
</ul>

    </div>
                
             </div>
    
    {/* ✅ Models & Model Values */}
    <h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Models for</h2>
    <div className="grid grid-cols-1 gap-4 text-center mb-6">
       <p className="text-xl md:text-2xl opacity-90">FISH & SEAFOOD  <span className=' text-blue-400'>-1… +5 °C</span> <span className='text-gray-500'>(4M1)</span></p>
       </div>

            {/* case 2 */}
             <div 
               className="flex flex-col  pb-16 mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/columcase1.jpg" className="max-w-full h-auto object-contain" />
               </div>
    
               <div className="w-full md:w-1/2 px-4"> 
        <p className="text-2xl">Visibility and freshness for Fish & Seafood!</p>
        <ul className="list-[square] list-outside text-gray-500">
  <li className="text-xl  font-thin opacity-90 mt-6">
    Static refrigeration with cooled cover and ice bucket.
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
    Line predisposed for remote condensing units.
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
    Stainless steel inside, resistant and easy to sanitize.
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
    Wide exposition area with 95 cm.
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
    Total visibility, front glass without any technical element.
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
    Version with pedestal or with front decoration, which adapts to your business style.
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
    LED lighting of high brightness and high energy efficiency.
  </li>
</ul>
    </div>
             </div>
    
{/* ✅ Models & Model Values */}
<h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Models for</h2>
    <div className="grid grid-cols-1  text-center mb-6">
       <p className="text-xl md:text-2xl opacity-90">COLD MEATS AND SALADS <span className=' text-blue-400'>-1… +7 °C</span> <span className='text-gray-500'>(3M2)</span></p>
       <p className="text-xl md:text-2xl opacity-90">HOT MEALS <span className=' text-gray-500'>(fan assisted)</span> <span className='text-red-500'> +60… +65 °C</span></p>
       <p className="text-xl md:text-2xl opacity-90">HOT MEALS <span className=' text-gray-500'>(water bath)</span> <span className='text-red-500'> +60… +65 °C</span></p>

       </div>

    {/* case 3 */}
    <div 
               className="flex flex-col  pb-16 mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4"> 
        <p className="text-2xl">Rice dishes, Lasagnes, Salads, …, ready to go!</p>
        <ul className="list-[square] list-outside text-gray-500">
  <li className="text-xl  font-thin opacity-90 mt-6">
    Complete take-away service, fan-assisted refrigerated, fan-assisted heated, and water bath models.
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
    Line predisposed for remote condensing units.
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
    Stainless steel inside, resistant and easy to sanitize.
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
    Wide exposition area with 95 cm.
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
    Total visibility, front glass without any technical element.
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
    Version with pedestal or with front decoration, which adapts to your business.
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
    LED lighting of high brightness and high energy efficiency.
  </li>
</ul>

    </div>
                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/columcase2.jpg" className="max-w-full h-auto object-contain" />
               </div>
             </div>
    
           
         </div>
    
     </div>
    
        </div>
      )
    }

export default Columbs